import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../base-modal/base-modal.component";
import {MatTab, MatTabChangeEvent, MatTabGroup} from "@angular/material/tabs";
import {MatButton} from "@angular/material/button";
import {BloggerGroupsService} from "../services/blogger-groups.service";
import {AttachDetachBloggersByGroup, BloggerGroupsData, CreateBloggerGroupParams} from "../types/blogger-groups.types";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {BloggerGroupsStateService} from "../services/blogger-groups-state.service";
import {newBloggerGroupsModalName} from "../configs/new-blogger-groups-config";
import { FormsModule } from "@angular/forms";
import { MatListOption, MatSelectionList } from "@angular/material/list";

@Component({
  selector: 'app-new-blogger-groups-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    MatTab,
    MatTabGroup,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    FormsModule,
    MatSelectionList,
    MatListOption
  ],
  templateUrl: './new-blogger-groups-modal.component.html',
  styleUrl: './new-blogger-groups-modal.component.scss'
})
export class NewBloggerGroupsModalComponent extends BaseModalComponent {
  private bloggerGroupsStateService: BloggerGroupsStateService = inject(BloggerGroupsStateService);
  private dialogData = inject<Array<number>>(MAT_DIALOG_DATA);
  private bloggerGroupsService: BloggerGroupsService = inject(BloggerGroupsService);

  public groupName: string = '';
  public searchBloggerGroupName: string = '';
  public bloggerGroups: Array<BloggerGroupsData> = [];
  public selectedBloggerGroup: Array<BloggerGroupsData> = [];
  private selectedTabIndex: number = 0;

  public override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.modalStatesService.openModal(newBloggerGroupsModalName);
    this.loadingService.setIsLoadingState(true);
    await this.bloggerGroupsService.getBloggerGroupsData();
    this.bloggerGroups = this.bloggerGroupsStateService.bloggerGroups();
    this.loadingService.setIsLoadingState(false);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(newBloggerGroupsModalName);
  }

  public handleTabChange(event: MatTabChangeEvent): void {
    this.selectedTabIndex = event.index;
    this.groupName = '';
  }

  public getAttachTabLabel(): string {
    const count = this.bloggerGroupsStateService.bloggerGroups().length || '-';
    return `Прикрепить к существующей ${count}`
  }

  public loadBloggerGroups() {
    if (!this.searchBloggerGroupName) {
      this.bloggerGroups = this.bloggerGroupsStateService.bloggerGroups();
    }

    this.bloggerGroups = this.bloggerGroupsStateService.bloggerGroups().filter(bloggerGroup => bloggerGroup.name.toLowerCase().includes(this.searchBloggerGroupName.toLowerCase()));
  }

  public getTextBtn(): string {
    return this.selectedTabIndex ? 'Прикрепить' : 'Создать';
  }

  public async handleClick(): Promise<void> {
    this.selectedTabIndex ? await this.handleAttachBloggers() : await this.handleCreateGroup();
  }

  public isDisabled(): boolean {
    return this.selectedTabIndex ? (!this.dialogData.length || !this.selectedBloggerGroup.length) : !this.groupName;
  }

  private async handleCreateGroup(): Promise<void> {
    const createBloggerGroupParams: CreateBloggerGroupParams = {
      name: this.groupName,
      bloggerIds: this.dialogData || []
    };

    await this.bloggerGroupsService.createBloggerGroup(createBloggerGroupParams);

    this.closeDialog('cancel');
  }

  private async handleAttachBloggers(): Promise<void> {
    if (!this.dialogData.length) {
      this.errorService.showErrorMessage('Не выборанны блогеры!')
      return;
    }

    const attachDetachBloggersByGroup: AttachDetachBloggersByGroup = {
      id: Number(this.selectedBloggerGroup[0].id),
      bloggerIds: this.dialogData
    };

    await this.bloggerGroupsService.attachBloggersByGroup(attachDetachBloggersByGroup)
      .then(() => {
        this.snackbarService.showMessage({message: 'Блогеры добавлены в группу'});
        this.closeDialog('success');
      })
      .catch(() => this.closeDialog('cancel'));
  }
}
